import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

const routes = [
  // ========== 无需登录的页面 ==========
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
    meta: { title: '登录' }
  },

  // ========== 加载过渡页 ==========
  {
    path: '/loading',
    name: 'loading',
    component: () => import('@/views/loadingPage/loadingPage.vue'),
    meta: { title: '加载中' }
  },

  // ========== 错误页 ==========
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/error/403.vue'),
    meta: { title: '无权限' }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '页面不存在' }
  },

  // ========== 静态业务路由（Layout 包裹） ==========
  {
    path: '/',
    component: Layout,
    redirect: '/order/list',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/dashboard.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      // 订单管理
      {
        path: 'order/list',
        name: 'order-list',
        component: () => import('@/views/order/list/orderList.vue'),
        meta: { title: '商户订单', icon: 'el-icon-tickets', parent: '订单管理' }
      },
      // 水电费管理
      {
        path: 'utility-bill/list',
        name: 'utility-bill-list',
        component: () => import('@/views/utilityBill/list.vue'),
        meta: { title: '水电费记录', icon: 'el-icon-document', parent: '水电费管理' }
      },
      // 系统管理
      {
        path: 'system/user',
        name: 'system-user',
        component: () => import('@/views/system/user/user.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user', parent: '系统管理' }
      },
      {
        path: 'system/userShop',
        name: 'system-userShop',
        component: () => import('@/views/system/userShop/userShop.vue'),
        meta: { title: '商户用户', icon: 'el-icon-user', parent: '商户管理' }
      },

      // 商户地市
      {
        path: 'system/shopCity',
        name: 'system-shopCity',
        component: () => import('@/views/system/shopCity/shopCity.vue'),
        meta: { title: '商户地市', icon: 'el-icon-office-building', parent: '系统管理' }
      },
      // 日志管理
      {
        path: 'system/log',
        name: 'system-log',
        component: () => import('@/views/system/log/log.vue'),
        meta: { title: '操作日志', icon: 'el-icon-document', parent: '日志管理' }
      },
      {
        path: 'system/fullLog',
        name: 'system-fullLog',
        component: () => import('@/views/system/fullLog/fullLog.vue'),
        meta: { title: '日志归档', icon: 'el-icon-files', parent: '日志管理' }
      },
      {
        path: 'system/logStatistics',
        name: 'system-logStatistics',
        component: () => import('@/views/system/logStatistics/logStatistics.vue'),
        meta: { title: '日志统计', icon: 'el-icon-data-analysis', parent: '日志管理' }
      },
      // 消息管理
      {
        path: 'system/notice',
        name: 'system-notice',
        component: () => import('@/views/system/notice/notice.vue'),
        meta: { title: '通知管理', icon: 'el-icon-bell', parent: '消息管理' }
      },
      {
        path: 'system/smsRecord',
        name: 'system-smsRecord',
        component: () => import('@/views/system/smsRecord/smsRecord.vue'),
        meta: { title: '短信记录', icon: 'el-icon-message', parent: '消息管理' }
      }
    ]
  },

  // 兜底：未匹配路由跳 404
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router
